import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

const IDEMPOTENT_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);
const RETRY_COUNT = 2;
const RETRY_DELAY_MS = 500;

export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  if (!IDEMPOTENT_METHODS.has(req.method)) return next(req);

  return next(req).pipe(
    retry({
      count: RETRY_COUNT,
      delay: (err: HttpErrorResponse) => {
        if (err.status === 0) return timer(RETRY_DELAY_MS);
        return throwError(() => err);
      },
    }),
  );
};
